import * as React from 'react';
import { ModalBody, Modal, ModalFooter, ModalSize, FileUpload, Form, CustomSubmitButton, CustomButton, ButtonType, HiddenInput, Checkbox } from "soprasteria-ui-library";
import { megaBytesToBytes } from '../../../helpers/FileHelper';
import { IListItem } from 'soprasteria-ui-library/dist/models/IFormInput';
import { useAuth } from '../../../App';
import { RiskPotReportDocumentApi } from "../../../api/RiskPotReportDocumentApi";
import { IRiskPotReportAttachment } from '../../../models/IRiskPotReport';
import { PhysicalFilesUpload } from './PhysicalFilesUpload';
import { LibrettoFileUpload } from '../../FileUpload/LibrettoFileUpload';

interface IRiskPotReportAttachmentsModal {
    getRiskPotReport: () => void;
    riskPotReportId: number;
    setShowForm: React.Dispatch<React.SetStateAction<boolean>>;
    showForm: boolean;
}

export const RiskPotReportAttachmentsModal: React.FunctionComponent<IRiskPotReportAttachmentsModal> = ({ getRiskPotReport, riskPotReportId, setShowForm, showForm }) => {

    const auth = useAuth();
    var api = new RiskPotReportDocumentApi(auth)
    const [isUploadingFiles, setIsUploadingFiles] = React.useState<boolean>(false);
    const [showUploadForm, setShowUploadForm] = React.useState<boolean>(true);
    const [riskPotReportAttachmentCategories, setRiskPotReportAttachmentCategories] = React.useState<IListItem[]>([]);

    const uploadFiles = (data: IRiskPotReportAttachment[]) => {
        setIsUploadingFiles(true);
        api.uploadFiles(data, () => {
            document.getElementById("close-risk-pot-attachment-modal")?.click();
            getRiskPotReport();
        }, undefined, () => setIsUploadingFiles(false));
    }

    const savePhysicalFile = (data: IRiskPotReportAttachment) => {
        setIsUploadingFiles(true);
        api.savePhysicalFile(data, () => {
            document.getElementById("close-risk-pot-attachment-modal")?.click();
            getRiskPotReport();
        }, undefined, () => setIsUploadingFiles(false));
    }

    React.useEffect(() => {
        api.getRiskPotReportAttachmentCategories((categories) => {
            const newCategories = categories.map<IListItem>((category) => {
                return { text: category.description, value: category.riskPotReportAttachmentCategoryId.toString(), informationText: category.informationText }
            });
            setRiskPotReportAttachmentCategories(newCategories);
        });
    }, []);

    return (
        <Modal id="risk-pot-attachment-modal" modalSize={ModalSize.large} header="Lägg till dokument">
            {
                showForm ?
                    <Form onSubmit={showUploadForm ? uploadFiles : savePhysicalFile}>
                        <ModalBody>
                            <div className="row mt-3">
                                <div className="col-6">
                                    <Checkbox value="true" name="toggleFileType" id="toggleFileType" label="Fysik bilaga" onChange={() => setShowUploadForm(!showUploadForm)} />
                                </div>
                            </div>
                            <HiddenInput name="riskPotReportId" value={riskPotReportId.toString()} />
                            {
                                showUploadForm ?
                                    <LibrettoFileUpload isEditable={showUploadForm} attachmentCategories={riskPotReportAttachmentCategories ?? []} />
                                    : <PhysicalFilesUpload riskPotReportAttachmentCategories={riskPotReportAttachmentCategories} name="riskPotReportAttachment" required />
                            }

                        </ModalBody>
                        <ModalFooter>
                            <CustomButton buttonType={ButtonType.general} data-dismiss="modal" id="close-risk-pot-attachment-modal" buttonText="Avbryt" onClick={() => { setShowForm(false); setShowUploadForm(true); }} />
                            <CustomSubmitButton isLoading={isUploadingFiles}>Lägg till</CustomSubmitButton>
                        </ModalFooter>
                    </Form>
                    : null
            }
        </Modal >
    )
}
